import pub from './../public';
const type = pub.getLang();
const language = {
    'zh-hk': {
      up :'以上',
low:'以下',
      yuan:'元',
      wan: '萬',
    yi: '億',
      allSub:'全選',
      subEdit:'編輯',
      subDel:'刪除',
      bRange:'建築面積',
      sRange:'實用面積',
      rooms:'房/',
      buildyear:'年',
      notify:'推送提醒',
      cancelAll:'取消所有選項',
      confirm:'確定',
      pushTime:'推送時間',
      pushWay:'推送方式',
      pushSet:'推送設定',
      addfavSub:'心水訂閱',
      order:'排序',
      proSub:'樓盤訂閱',
      editProSub:'管理樓盤訂閱',
      loadingText: '加載中',
      noInfo: '你尚未創建訂閱條件，請按添加按鈕開發訂閱',
      noseaInfo:'暫時未有符合訂閱條件的樓盤',
      sale: '放售',
      rent: '放租',
      residential: '住宅',
      offices: '工商',
      park:'車位',
      shop:'店鋪',
      land:'土地',
      landlord: '业主盤',
      agency: '代理盤',
      pushRemain:[
        "週一","週二","週三","週四","週五","週六","週日"
      ],
      allweek:'每日',
      subLimit:'已達到訂閱數量上限，',
      subLimitAfter:'請通過管理移除不需要的訂閱。',

    keyCon: '確定',
    okCon:'OK',
    knowBut:'知道了',
    editSub:'別太貪心，每次只能修改一個訂閱喔 ！',
    favSub:'別太貪心，每次只能設置一個訂閱喔 ！',

    delsub:'確定刪除「',
    delsubBot:'」嗎？',
    delSubs:'確定刪除已選擇的所有訂閱嗎？',
    canBtn:'取消',

    },
    "zh-cn": {
      up :'以上',
low:'以下',
      yuan:'元',

      wan: '万',
      yi: '亿',
      allSub:'全选',
      subEdit:'编辑',
      subDel:'删除',
      bRange:'建筑面积',
      sRange:'实用面积',
      rooms:'房/',
      buildyear:'年',
      notify:'推送提醒',
      cancelAll:'取消所有选项',
      confirm:'确定',
      pushTime:'推送时间',
      pushWay:'推送方式',

      pushSet:'推送设定',
      addfavSub:'心水订阅',
        subLimit:'已达到订阅数量上限,',
        subLimitAfter:'请通过管理移除不需要的订阅',
        allweek:'每日',
        keyCon: '确定',
      okCon:'OK',
      knowBut:'知道了',
        editSub:'别太贪心,每次只能修改一个订阅哦 ！',
        favSub:'别太贪心,每次只能设置一个订阅哦 ！',
        order:'排序',
        proSub:'楼盘订阅',
        editProSub:'管理楼盘订阅',
        loadingText: '加载中',
        noInfo: "你尚未创建订阅条件，请按添加按钮开发订阅",
        noseaInfo:'暂时未有符合订阅条件的楼盘',

        sale: '放售',
        rent: '放租',
        residential: "住宅",
        offices: "工商",
        park:'车位',
        shop:'店铺',
        land:'土地',
        landlord: '业主盘',
        agency: '代理盘',
        pushRemain:[
          "周一","周二","周三","周四","周五","周六","周日"
        ],
        delsub:'确定删除「',
        delsubBot:'」吗？',
        delSubs:'确定删除已选择的所有订阅吗？',
        canBtn:'取消',
    },
    "en-us": {
      up :'+',
low:'Below ',
      yuan:'HKD',
      canBtn:'Cancel',
      wan: 'M',
      yi:'亿',
      allSub:'All',
      subEdit:'Edit',
      subDel:'Delete',
      bRange:'GFA ',
      sRange:'SA ',
      rooms:'room/',
      buildyear:'years',
      notify:'Push Notification',
      cancelAll:'Clear',
      confirm:'Confirm',
      pushTime:'Push Time',
      pushWay:'Push Method',

      pushSet:'Push Settings',
      editProSub:'Manage Property Subscription',
      addfavSub:'Favorite Subscription',
      proSub:'Property Subscription',
      editSub:'You can only modify 1 subscription at a time',
      favSub:'You can only create 1 subscription at a time',
      loadingText: 'loading',
      noInfo: 'You have not created a subscription conditionPlease click the "Add" button at the todevelop a subscription',
      noseaInfo:'Currently, there are no properties that match your subscription criteria.',
      sale: 'For Sale',
      rent: 'For Rent',
      residential: "Residential",
      offices: "Commercial",
      park:'Car Park',
      landlord: 'Landlord',
      agency: 'Agency',
      keyCon: 'OK',
      okCon:'OK',
      knowBut:'OK',
      allweek:'EveryDay',
      subLimit:'The subscription limit has been reached.',
      subLimitAfter:' Please remove any unnecessary subscriptions.',
      order:'Sort',
      shop:'Shop',
      land:'Land',
      pushRemain:[
        "Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"
      ],
      delsub:'Are you sure you want to delete[',
      delsubBot:']?',
      delSubs:'Are you sure you want to delete all selected subscriptions?',
    },
  }
  export default language[type]